import React from 'react';
import { Menu, Bell } from 'lucide-react';
import { useUser } from '../../user/UserProvider';
import UserProfileImage from '../UserProfileImage'; // Reusing existing avatar component if possible, or build new

const DashboardHeader = ({ toggleSidebar }) => {
  const { userProfile } = useUser();

  return (
    <header className="h-16 bg-white/80 dark:bg-slate-900/80 backdrop-blur-md border-b border-slate-200 dark:border-slate-800 sticky top-16 z-40 px-4 sm:px-6 lg:px-8 flex items-center justify-between">
      <div className="flex items-center gap-4">
        <button 
            onClick={toggleSidebar}
            className="p-2 -ml-2 rounded-lg text-slate-600 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800 lg:hidden"
        >
            <Menu size={24} />
        </button>
        
        <div>
            <h1 className="text-lg font-semibold text-slate-900 dark:text-white hidden sm:block">
                Welcome back, {userProfile?.firstName || 'Member'}!
            </h1>
        </div>
      </div>

        <div className="flex items-center gap-4">
            {/* Quick Actions or Notifications could go here */}
            {/* <button className="p-2 rounded-full text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors relative">
                <Bell size={20} />
                <span className="absolute top-2 right-2 w-2 h-2 bg-red-500 rounded-full border-2 border-white dark:border-slate-900"></span>
            </button> */}
            
            <div className="flex items-center gap-3 pl-4 border-l border-slate-200 dark:border-slate-700">
                <div className="text-right hidden md:block">
                    <p className="text-sm font-medium text-slate-900 dark:text-white">
                        {userProfile?.firstName} {userProfile?.lastName}
                    </p>
                    <p className="text-xs text-slate-500 dark:text-slate-400">
                        {userProfile?.username || 'Member'}
                    </p>
                </div>
                {/* We can reuse the UserProfileImage logic or a simple avatar here */}
                 <div className="w-10 h-10 rounded-full bg-blue-100 dark:bg-blue-900 flex items-center justify-center text-blue-600 dark:text-blue-300 font-bold overflow-hidden border-2 border-white dark:border-slate-700 shadow-sm">
                    {userProfile?.userMedia?.mediaUrl ? (
                         <img src={userProfile.userMedia.mediaUrl} alt="Profile" className="w-full h-full object-cover" />
                    ) : (
                        <span>{userProfile?.firstName?.charAt(0)}</span>
                    )}
                 </div>
            </div>
        </div>
    </header>
  );
};

export default DashboardHeader;
